<template>
  <div class="patient-grid">
    <div
      v-for="avatarRecord in avatarList"
      :key="avatarRecord.id"
      class="image-outer"
    >
      <div
        class="image-inner"
        :class="{ 'image-inner-disabled': disabledAvatarKeys.includes(avatarRecord.key) }"
        @click="selectAvatar(avatarRecord)"
      >
        <div
          class="thumbnail-wrapper"
          :class="{ 'thumbnail-selected': avatarRecord.key === selectedAvatarKey }"
          :aria-label="`${avatarRecord.selectionName.en} Thumbnail`"
          :data-testid="`thumbnail-${avatarRecord.key}`"
        >
          <img
            :src="pictureFor(avatarRecord)"
            class="thumbnail-img"
            :alt="avatarRecord.selectionName.en"
          >
        </div>
        <span>{{ avatarRecord.selectionName.en }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';

export default {
  name: 'patient-grid',
  props: {
    avatars: {
      type: Array,
      default: () => []
    },
    selectedAvatarKey: {
      type: String,
      default: null
    },
    allowUnselected: {
      type: Boolean,
      default: false
    },
    disabledAvatarKeys: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      unselected: {
        key: null,
        id: 'unselected',
        selectionName: {
          en: 'No VIP'
        }
      }
    }
  },
  computed: {
    avatarList() {
      if (this.allowUnselected) {
        return [ this.unselected ].concat(this.avatars);
      }
      return this.avatars;
    },
  },
  methods: {
    pictureFor(location) {
      return get(location, 'picture.url', require('@/assets/icons/character-unselected.svg'));
    },
    selectAvatar(avatar) {
      this.$emit('select', avatar)
    }
  }
}
</script>

<style scoped>
.patient-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px; /* automatically spaces between items, but no gap on the outer edge */
}

.image-outer {
  display: inline-block;
}

.image-inner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.image-inner-disabled {
  opacity: 0.4;
  pointer-events: none;
}

.thumbnail-wrapper {
  aspect-ratio: 1 / 1;
  width: 160px;
  height: 160px;
  overflow: hidden;
  margin-bottom: 8px;
}

.thumbnail-selected {
  outline: 4px solid #3f83c5;
}

.thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  box-sizing: border-box;
  cursor: pointer;
}
</style>